export const smallSmartphonePortrait = window.matchMedia('(max-width: 420px)');
export const smartphonePortrait = window.matchMedia('(max-width: 590px)');
export const smartphoneLandscape = window.matchMedia('(max-width: 960px)');
export const tabletLandscape = window.matchMedia('(max-width: 1280px)');
export const desktop = window.matchMedia('(min-width: 1281)');

export default {
  smallSmartphonePortrait,
  smartphonePortrait,
  smartphoneLandscape,
  tabletLandscape,
  desktop,
};
